// import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import log from '@/plugin/logger.ts'
import router from '@/router'



/**********************************************************************
 * Axios
 **********************************************************************/
/**
 * 통신을 관리하는 메소드
 * @param {*} rawConfig 
 * @returns 
 */
// ✅ 전역 설정 (한 번만 하면 모든 axios 요청에 반영됨)
axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.withCredentials = true
axios.defaults.headers.common['Accept'] = '*/*'
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.response.use(
  res => res,
  async error => {
    console.error('Axios Error:', error);

    if (
      error.response &&
      error.response.status === 403 &&
      (error.response.data?.code === 'SESSION_EXPIRED' || error.response.headers['x-session-expired'] === '1')
    ) {
      // Vuex나 Pinia 스토어 클리어
      if (window.$store) {
        window.$store.commit('auth/logout');
      }

      // localStorage, sessionStorage 클리어
      localStorage.clear();
      sessionStorage.clear();

      // 로그인 페이지로 리다이렉트
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
)

/**
 * Title        : http
 * Status       : Actived
 * Description  : axios 통신을 관리하는 메소드
 * 
 * @param {*} rawConfig 
 * @returns 
 */
const http = async (rawConfig) => {
  log.debug("[ http / rawConfig ] = ", rawConfig)
  
  let rePackedConfig = {
    url   : rawConfig.url,
    method: rawConfig.method,
    data  : rawConfig?.headers == "multipart" ? rawConfig?.formData : rawConfig.data,
    name  : rawConfig?.name,
    ...(Number.isFinite(rawConfig?.timeout) && rawConfig.timeout > 0 ? { timeout: rawConfig.timeout } : {}),
    responseType : rawConfig?.responseType ? rawConfig?.responseType : 'json',
    headers: {
      // 추가
      "Accept": "*/*",
      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Credentials": "true",
      "Content-Type": rawConfig?.headers == "multipart" ? "multipart/form-data" : "application/json"
    },
    withCredentials : true // send cookies when cross-domain requests
  }

  log.debug("[ http / rePackedConfig ] = ", rePackedConfig)

  if (!rawConfig?.skipSpinner) {
    store.dispatch('showSpinner')
  }

  return axios(rePackedConfig)
    .then((res) => {
      log.debug((rawConfig?.name != undefined ? rawConfig?.name : "Axios 이름이 없습니다.") + " => ", res)
      const status = res.status
      
      switch (status) {
        case 200 :
          log.debug(`${rawConfig?.name} 실행됨`)
          break;
        default :
          log.debug(`${rawConfig?.name} 실행됨`)
      }
      return res
    })
    .catch((err) => {
      // TODO : Catch 단계의 오류 정리 필요
      log.error(`${rawConfig?.name} 에서 오류가 발생되었습니다. ${err}`)
      
      // 오류 상태 코드
      const status = err.response?.status
      // 오류 영문 코드
      const code = err.code

      if (status === 401 || status === 403) {
        const errCode = err.response?.data?.code
        if (errCode === 'SESSION_EXPIRED' || err.response?.headers?.['x-session-expired'] === '1') {
          router.push('/login')
          return
        }
      }

      if (code === "ERR_NETWORK") {
        log.error("네트워크 오류가 있습니다.", code)
      }
      throw err
    })
    .finally(() => {
      if (!rawConfig?.skipSpinner) {
        store.dispatch('killSpinner')
      }
    })
}



/**
 * Title        : 세션체크
 * Status       : Actived
 * Description  : -
 */
// 세션 체크
const checkSession = async () => {
  let config = {
    method  : "get",
    url     : "/api/cust/getSession",
    name    : "[ Axios / 고객 세션확인 ]"
  }
  
  await http(config)
    .then(res => {
      log.debug("1. Result check session => ", res)
      // cookie 에서 passport 내용 추출
      const passport = res.data.passport

      // passport 가 없는 경우
      if(passport === undefined){
        
        log.debug('1.1 로그인 되어있지 않음')
        store.dispatch('destroyCustomerInfo')
        sessionStorage.removeItem('vuexStore')

      } else {
        
        log.debug('1.2 로그인 되어있음 isSignedIn = ', passport.user)
        
        // 로그인 성공 후 넘어온 고객의 정보를 Vue storage에 넣는다.
        store.dispatch('setCustomerInfo', passport.user)

      }

    }).catch(error => {

      log.debug("3.3 Result check session has error => ", error)
      store.dispatch('destroyCustomerInfo')
      sessionStorage.removeItem('vuexStore')
      alert('router 이동 시 세션 체크중 오류가 발생했습니다.')
      router.push('/login')
    
    })
}


/**
 * Title        : 권한레벨 가져오기
 * Status       : Actived
 * Description  : -
 */
const getAuthLevel = () => {
  // 관리자 페이지 이므로 관리자가 아닌 경우 일반사이트로 이동을 시킨다.
  const sess = JSON.parse(sessionStorage.getItem('vuexStore'))
  
  let sessionData = sess?.user
  if (sessionData !== undefined) {
    return sessionData.localSession.authLevel
  }
  return "00"
}


/**
 * Title        : 디바이스 타입 확인
 * Status       : Actived
 * Description  : 디바이스 타입을 확인하여 mobile 또는 desktop을 반환한다.
 * 
 * @param { String } data 
 * @returns string data or true
 */
/**********************************************************************
 * Validation
 **********************************************************************/
/**
 * Title        : 한글만 입력 가능하도록 하는 함수
 * Status       : Actived
 * Description  : 한글과 공백만 입력 가능하도록 하는 함수
 * 
 * @param { String } data 
 * @returns string data or true
 */
const validKor = (data) => {
    let regExp = /^[가-힣\s]+$/
    // log.debug("data = " + data.length)
    // log.debug("regExp result = " + regExp.test(data))
    if (data.length > 0) {
        return regExp.test(data)
    } else {
        return true
    }
}

/** 
 * Title        : 휴대전화 번호 유효성 검사
 * Status       : Actived
 * Description  : 휴대전화 번호에서 숫자만 추출하여 반환한다.
 * 
 * @param { String } data 
 * @returns string data
 */
const validMobile = (data) => {
    log.debug("validMobile executed => " + data)
    // 숫자를 제외한 문자제거
    return data.replace(/[^0-9]/g, '')
}

/**
 * Title        : 이메일 형식 검증
 * Status       : Actived
 * Description  : 이메일 형식을 검증한다.
 * @param { String } data 
 * @returns boolean
 */
const validEmail = (data) => {
    // 이메일 형식 검증
    let regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
    // log.debug("data = " + data)
    // log.debug("regExp result = " + regExp.test(data))
    let result = regExp.test(data)
    if (data.length > 0 && !result) {
        alert("잘못된 이메일 형식입니다.")
        return result
    } else {
        return true
    }
}

/**
 * Title        : 빈 오브벡트 확인
 * Status       : Actived
 * Description  : 빈 오브젝트를 확인하여 빈 오브젝트가 있는 경우 리스트를 반환한다.
 * @param { Object } data
 * @return { Array } emptyList
 */ 
const checkEmpty = (data) => {
    // 전달받은 원본 데이터
    let resData = data
    // 전달 받은 데이터에서 Key를 추출한다
    let keyArr = Object.keys(data)
    log.debug("Extracted keyArr = ", keyArr)

    // required 속성을 가지고 있지만 값이 없는 항목의 key를 리턴하여 Array를 만든다
    let emptyList = keyArr.filter(key => {
        const thisKey = resData[key]
        log.debug("resData[key].value = " + thisKey.value)
        log.debug("resData[key].required = " + thisKey.required)
        if ((thisKey?.value === "" || thisKey?.value === undefined) && thisKey?.required === true || thisKey?.required === undefined) {
            return key
        }
    })
    log.debug("emptyList = ", emptyList)

    return emptyList
}

/**
 * Title        : 빈 오브벡트 확인
 * Status       : Actived
 * Description  : 빈 오브젝트를 확인하여 빈 오브젝트가 있는 경우 리스트를 반환한다.
 * 
 * @param { v model data } data 
 * @returns 
 */
const checkEmptyVModelList = (data) => {
    
  // 전달 받은 데이터에서 Key를 추출한다
  let keyArr = Object.keys(data)
  log.debug("Extracted keyArr = ", keyArr)

  // required 속성을 가지고 있지만 값이 없는 항목의 key를 리턴하여 Array를 만든다
  let emptyList = keyArr.filter(key => {
    log.debug("key = " + key)

    const thisVal = data[key]
    log.debug("data[key].value = " + thisVal)

    if (thisVal === "" || thisVal === undefined) {
        return key
    }
  })
  log.debug("emptyList are = ", emptyList)

  return emptyList
}

/**
 * Title        : v-model object list 빈값 체크
 * Status       : Actived
 *  
 * @param { Array } data - [{ label: '이름', modelValue: '' }, ...]
 * @returns { Array } - modelValue가 빈 항목의 label만 배열로 반환
 */ 
const checkEmptyRefList = (data) => {
  // data: [{ label: '이름', modelValue: '' }, ...]
  // modelValue가 빈 항목의 label만 배열로 반환
  return data
    .filter(item => item.modelValue === '' || item.modelValue === undefined)
    .map(item => item.label)
}

/**
 * Title        : v-model object list 유효성 체크 (Quasar validate)
 * Status       : Actived
 * Description  : Quasar의 ref 배열에서 validate()가 false인 항목의 label만 배열로 반환
 * @param { Array } refs - [{ label: '이름', ref: QInputRef }, ...]
 * @returns { Array } - validate()가 false인 항목의 label만 배열로 반환
 */
const checkInvalidRefList = (refs) => {
  log.debug("checkInvalidRefList executed with refs =", refs);
  const invalidLabels = [];
  for (const item of refs) {
    log.debug("checkInvalidRefList executed with refs 1 =", item);
    if (item && typeof item.validate === 'function') {
      const valid = item.validate();
      log.debug("checkInvalidRefList executed with refs 2 valid = ", valid);
      if (!valid) {
        invalidLabels.push(item.label);
      }
    }
  }
  return invalidLabels;
}

// Quasar의 form rules에서 바로 사용할 수 있는 공통 validation 룰 모음
const validationSet = {
  // 영문만
  alpha: val =>
    !val || /^[A-Za-z\s]+$/.test(val) || '영문만 입력 가능합니다.',
  // 영문 + 숫자
  alphaNum: val =>
    !val || /^[A-Za-z0-9\s]+$/.test(val) || '영문과 숫자만 입력 가능합니다.',
  // 상품명: 영문 + 숫자 + 괄호
  itemName: val =>
    !val || /^[A-Za-z0-9\s()]+$/.test(val) || '상품명은 영문, 숫자, 괄호만 입력 가능합니다.',
  // 한글만
  korean: val =>
    !val || /^[가-힣\s]+$/.test(val) || '한글만 입력 가능합니다.',
  // 한글 + 숫자
  korNum: val =>
    !val || /^[가-힣0-9\s]+$/.test(val) || '한글과 숫자만 입력 가능합니다.',
  // 숫자만
  num: val =>
    !val || /^[0-9\s]+$/.test(val) || '숫자만 입력 가능합니다.',
  // 최대 길이 체크: rules.maxLength(10)
  maxLength: (max) => (val) =>
    !val || String(val).length <= max || `최대 ${max}자까지 입력 가능합니다.`,
  // 최소 길이 체크: rules.minLength(3)
  minLength: (min) => (val) =>
    !val || String(val).length >= min || `최소 ${min}자 이상 입력해야 합니다.`,
  // 영문 주소 (영문 + 숫자 + 하이픈/공백)
  engAddr: val =>
    !val || /^[A-Za-z0-9\s-]+$/.test(val) || '영문과 숫자만 입력 가능합니다.',
  // 한글 주소 (한글 + 숫자 + 하이픈/공백)
  korAddr: val =>
    !val || /^[가-힣0-9\s-]+$/.test(val) || '한글과 숫자만 입력 가능합니다.',
}





/**********************************************************************
 * Prevent input
 **********************************************************************/
const preventSet = {
  kor: (val) => {
    if (/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(val)) {
      return val.replace(/[^a-zA-Z0-9]/g, '')
    } else {
      return val
    }
  }
}








/**********************************************************************
 * 자주 쓰이는 목록
 **********************************************************************/

/**
 * Title        : 택배사 목록조회
 * Status       : Actived
 * Description  : 택배사 목록을 조회하여 Store에 위치시킨다.
 */
const getCourierList = () => {
  let isCourierLoaded = store.getters.getCourierList
  // log.debug("택배사 목록 조회", isCourierLoaded)
  
  if(isCourierLoaded.length > 0){
    log.debug("택배사 목록이 이미 조회되어 있습니다.")
  } else {
    let config = {
      method  : "get",
      url     : "/api/courier/getCourierList",
      name    : "[ AXIOS / 택배사 목록조회 ]" 
    }

    http(config)
      .then(res => {
      let tempRtn = res.data
      // log.debug("/admin/getCourierList 실행됨", tempRtn)
        store.dispatch('loadCourier', tempRtn)
      })
  }
}

/**
 * Title        : 택배사 이름 조회
 * Status       : Actived
 * Description  : 택배사 코드를 통해 택배사 이름을 조회한다.
 * @param { String } code - 택배사 코드
 * @returns { String } - 택배사 이름
 */
const getCourierName = (code) => {
  
  let courierList = store.getters.getCourierList
  const courierName = (courierList.find(item => item.value === code) || {}).label
  // log.debug(courierName)  // 출력: '로젠택배'

  return courierName ? courierName : ''
}

/**
 * Title        : 배송상품 위치목록조회
 * Status       : Actived
 * Description  : 배송상품 위치목록을 조회하여 Store에 위치시킨다.
 */
const getParcelLocationList = () => {
    let isLoaded = store.getters.getParcelLocationList

    if(isLoaded.length > 0){
        log.debug("배송상품 위치 목록이 이미 조회되어 있습니다.")
    } else {
      let config = {
        method  : "get",
        url     : "/api/parcelLocation/getParcelLocationList",
        name    : "[ AXIOS / 배송상품 위치 목록 ]" 
      }
  
      http(config)
        .then(res => {
          let tempRtn = res.data
          log.debug("/parcelLocation/getParcelLocationList 실행됨", tempRtn)
          store.dispatch('loadParcelLocation', tempRtn)
        })
    }
}


/**
 * Title        : 픽업지 목록조회
 * Status       : Actived
 * Description  : 픽업지목록을 조회하여 Store에 위치시킨다.
 */
const getPickupLocationList = async () => {
    let isLoaded = store.getters.getPickupLocationList

    if(isLoaded.length > 0){
        log.debug("픽업지 목록이 이미 조회되어 있습니다.", isLoaded)
    } else {
      let config = {
        method  : "get",
        url     : "/api/pickup/getPickupLocationList",
        name    : "[ AXIOS / 픽업지 목록 ]" 
      }
  
      await http(config)
        .then(res => {
          let tempRtn = res.data
          // log.debug("/admin/getPickupLocationList 실행됨", tempRtn)
          store.dispatch('loadPickupLocation', tempRtn)
        })
    }
}


/**
 * Title        : 목적도시 조회
 * Status       : Actived
 * Description  : 목적지 - 도시를 조회하여 Store에 담는다.
 */
const getCityList = () => {
  let isLoaded = store.getters.getPickupLocationList

  if(isLoaded.length > 0){
      log.debug("목적지(도시) 목록이 이미 조회되어 있습니다.")
  } else {
    let config = {
      method  : "get",
      url     : "/api/code/getCityList",
      name    : "[ AXIOS / 목적지(도시) 목록 ]" 
    }

    http(config)
      .then(res => {
        let tempRtn = res.data
        // log.debug("/api/destination/getCityList 실행됨", tempRtn)
        store.dispatch('fetchCityList', tempRtn)
      })
  }
}


/**
 * Title        : 운송수단 조회
 * Status       : Actived
 * Description  : 운송수단를 조회하여 Store에 담는다.
 */
const getFreightList = () => {
  let isLoaded = store.getters.getFreightMethodList

  if(isLoaded.length > 0){
      log.debug("운송수단 목록이 이미 조회되어 있습니다.")
  } else {
    let config = {
      method  : "get",
      url     : "/api/code/getFreightMethodList",
      name    : "[ AXIOS / 운송수단 목록 ]" 
    }

    http(config)
      .then(res => {
        let tempRtn = res.data
        store.dispatch('fetchFreightList', tempRtn)
      })
  }
}


/**
 * Title        : 권한 레벨 목록 불러오기
 * Status       : Actived
 * Description  : 권한레벨 목록을 불러온다.
 */
const getMemberLevelList = () => {
  let isLoaded = store.getters.getMemberLevelList

  if(isLoaded.length > 0){
    log.debug("권한 레벨 목록이 이미 조회되어 있습니다.")
  } else {
    let config = {
      method  : "get",
      url     : "/api/code/getMemberLevelList",
      name    : "[ AXIOS / 멤버권한목록 ]"
    }

    http(config)
      .then(res => {
        let tempRtn = res.data
        // log.debug("/api/code/getMemberLevelList 실행됨", tempRtn)
        store.dispatch('fetchMemberAuthLevelList', tempRtn)
      })
  }
}


/**
 * Title        : 파트너 목록 불러오기
 * Status       : Actived
 * Description  : 파트너 목록을 불러온다.
 */
const getPartnerList = () => {
  let isLoaded = store.getters.getPartnerList

  if(isLoaded.length > 0){
    log.debug("파트너 목록이 이미 조회되어 있습니다.")
  } else {
    let config = {
      method  : "post",
      url     : "/api/partner/getPartnerList",
      name    : "[ AXIOS / 파트너목록 ]"
    }

    http(config)
      .then(res => {
        let tempRtn = res.data
        log.debug("/api/partner/getPartnerList 실행됨", tempRtn)
        store.dispatch('fetchPartnerList', tempRtn)
      })
  }
}



/**
 * Title        : 코드목록 불러오기
 * Status       : Actived
 * Description  : 코드목록을 불러온다.
 * 
 * TODO: 기존 코드 리스트가 존재하는 경우에는 불러오지 않도록 처리해야 한다.
 * 
 */
const getCodeList = async (code, parent) => {
  
  log.debug("불러올 부모코드가 있을 경우 = ", parent)
  log.debug("불러올 코드목록 = ", code)

  let payload = {
    parentCode : parent,
    code : code
  }

  let config = {
    method  : "POST",
    url     : "/api/code/getCodeList",
    data    : payload,
    name    : `[ AXIOS / 코드목록 불러오기 / ${code} ]`,
  }

  await http(config)
    .then(res => {
      let tempRtn = res.data

      switch(code){
        case 'NATION':
          store.dispatch('actNationList', tempRtn)
          break;

        case 'CIT':
          store.dispatch('actCityList', tempRtn)
          break;

        case 'REGION':
          store.dispatch('actRegionList', tempRtn)
          break;

        case 'ORDSTT':
          store.dispatch('actOrderStatusList', tempRtn)
          break;

        case 'CONSTT':
          store.dispatch('actConsolStatusList', tempRtn)
          break;

        case 'BIZTYP':
          store.dispatch('actBizTypeList', tempRtn)
          break;

        case 'AUTHLV':
          store.dispatch('actAuthLevelList', tempRtn)
          break;

        case 'FREIGH':
          store.dispatch('actFreightList', tempRtn)
          break;

        case 'SEQTYP':
          store.dispatch('actSeqTypeList', tempRtn)
          break;

        case 'BRDTYP':
          store.dispatch('actBrdTypeList', tempRtn)
          break;
      }
    })
}




/**********************************************************************
 * Formatter
 **********************************************************************/
/**
 * Title        : 날짜 포맷 변환
 * Status       : Actived
 * Description  : ISO 형식의 날짜를 지정된 형식으로 변환한다.
 * 
 * @param { String } isoDate - ISO 형식의 날짜 (예: 2025-03-03T05:30:03.071Z)
 * @param { String } format - 변환할 형식 (예: "xxxx년 xx월 xx일", "MM/DD/YYYY", "YYYY-MM-DD HH:mm:ss")
 * @returns { String } 변환된 날짜 문자열
 */
const formatDate = (isoDate, format = "xxxx년 xx월 xx일") => {
  if (!isoDate) return ''
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return String(isoDate)

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return format
    .replace("YYYY", year)
    .replace("xxxx", year)
    .replace("HH", hours)
    .replace("mm", minutes)
    .replace("ss", seconds)
    .replace("xx월", `${month}월`)
    .replace("xx일", `${day}일`)
    .replace("MM", month)
    .replace("DD", day);
};


/**
 * Title        : 사업자번호 포맷
 * Status       : Actived
 * Description  : 사업자번호를 3-5-2 형식으로 변환한다.
 * @param {*} val 
 * @returns 
 */
const formatBusinessNumber = (val) => {
  if (!val || val.length !== 10) return val
  return `${val.slice(0, 3)}-${val.slice(3, 5)}-${val.slice(5)}`
}

/**
 * Title        : 전화번호 포맷
 * Status       : Actived
 * Description  : 전화번호를 형식에 따라 변환한다.
 * @param { String } phoneNumber - 전화번호 문자열
 * @param { String } type - 전화번호 유형 ("mobile" | "home")
 * @returns { String } 포맷된 전화번호
 */
const formatPhoneNumber = (phoneNumber, type) => {
  if (!phoneNumber) return phoneNumber;

  const cleaned = phoneNumber.replace(/[^0-9]/g, '');

  if (type === "mobile") {
    // 휴대전화: 010-1234-5678
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length === 11) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
    }
  } else if (type === "home") {
    // 집전화: 02-123-4567 or 031-123-4567
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length === 11) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
    }
  }

  return phoneNumber; // 반환할 수 없는 경우 원본 반환
};

/**
 * Title        : spec_key 생성
 * Status       : Actived
 * Description  : specType + specDetail로 spec_key 문자열 생성
 * @param { String } specType
 * @param { Object } specDetail
 * @returns { String }
 */
const makeSpecKey = (specType, specDetail = {}) => {
  if (!specType) return ''

  const type = String(specType).toUpperCase()
  const toNum = (val) => {
    if (val === null || val === undefined || val === '') return null
    const n = Number(val)
    return Number.isNaN(n) ? null : n
  }

  if (type === 'DIMENSION') {
    const l = toNum(specDetail.length_cm ?? specDetail.length)
    const w = toNum(specDetail.width_cm ?? specDetail.width)
    const h = toNum(specDetail.height_cm ?? specDetail.height)
    if (l === null || w === null || h === null) return ''
    return `${l}x${w}x${h}cm`
  }

  if (type === 'VOLUME') {
    const value = toNum(specDetail.volume_value ?? specDetail.value)
    if (value === null) return ''
    const unit = String(specDetail.volume_unit ?? specDetail.unit ?? 'ml')
    const ml = unit.toLowerCase() === 'l' ? Math.round(value * 1000) : value
    return `${ml}ml`
  }

  if (type === 'APPAREL_SIZE') {
    const size = specDetail.apparel_size ?? specDetail.size
    if (!size) return ''
    return `size:${String(size).toUpperCase()}`
  }

  if (type === 'PRODUCT_OPTION') {
    const stripSpaces = (value) => String(value || '').replace(/\s+/g, '')
    const model = stripSpaces(specDetail.model_code ?? specDetail.model)
    const color = stripSpaces(specDetail.color)
    const size = stripSpaces(specDetail.size ?? specDetail.size_value)
    if (!model || !color || !size) return ''
    return `model:${model}|color:${color}|size:${size}`
  }

  if (type === 'PACK_COUNT') {
    const unit = specDetail.pack_unit_type_code ?? specDetail.unit
    const count = toNum(specDetail.pack_count ?? specDetail.count)
    if (!unit || count === null) return ''
    return `${String(unit).toLowerCase()}-${count}ea`
  }

  return ''
}

export default {
    install(App) {
        /**************
        // http
        ***************/
        App.config.globalProperties.$http = http

        /**************
        // session check
        ***************/
        App.config.globalProperties.$checkSession = checkSession
        App.config.globalProperties.$getAuthLevel = getAuthLevel


        
        /**************
        // validation
        ***************/
        // 빈값 체크
        App.config.globalProperties.$checkEmpty = checkEmpty
        // v-model 인 object list를 넘겼을 때 값이 빈 경우 대상을 Array로 반환
        App.config.globalProperties.$checkEmptyVModelList = checkEmptyVModelList
        // ref 인 object list를 넘겼을 때 값이 빈 경우 대상을 Array로 반환
        App.config.globalProperties.$checkEmptyRefList = checkEmptyRefList
        // ref 인 object list를 넘겼을 때 validate()가 false인 항목의 label만 배열로 반환
        App.config.globalProperties.$checkInvalidRefList = checkInvalidRefList
        // 한글만 입력가능
        App.config.globalProperties.$validKor = validKor
        // 전화번호
        App.config.globalProperties.$validMobile = validMobile
        // 이메일
        App.config.globalProperties.$validEmail = validEmail
        // validation 룰셋
        App.config.globalProperties.$validationSet = validationSet
        // 입력방지 셋 - 실패했지만 다음 번을 위해 남겨 놓음
        App.config.globalProperties.$preventSet = preventSet

        /**************
        // formatter
        ***************/
        // 날짜
        App.config.globalProperties.$formatDate = formatDate
        // 사업자번호 포맷
        App.config.globalProperties.$formatBusinessNumber = formatBusinessNumber
        // 전화번호 포맷
        App.config.globalProperties.$formatPhoneNumber = formatPhoneNumber

        /**************
        // fulfillment
        ***************/
        App.config.globalProperties.$makeSpecKey = makeSpecKey

        
        /**************
        // 자주 쓰이는 목록
        ***************/
        // 택배사 목록 조회
        App.config.globalProperties.$getCourierList = getCourierList
        // 배송상품 위치 목록 조회
        App.config.globalProperties.$getParcelLocationList = getParcelLocationList
        // 픽업지 위치 목록 조회
        App.config.globalProperties.$getPickupLocationList = getPickupLocationList
        // 목적지 위치 목록 조회
        App.config.globalProperties.$getCityList = getCityList
        // 운송수단 조회
        App.config.globalProperties.$getFreightList = getFreightList
        // 권한목록 조회
        App.config.globalProperties.$getMemberLevelList = getMemberLevelList
        // 파트너목록 조회
        App.config.globalProperties.$getPartnerList = getPartnerList
        // 코드목록 조회
        App.config.globalProperties.$getCodeList = getCodeList


        /**************
        // 자주 쓰이는 맵핑
        ***************/
        App.config.globalProperties.$getCourierName = getCourierName

    }
}

export const common = {
    http,
    checkSession,
    getAuthLevel,
    checkEmpty,
    checkEmptyVModelList,
    checkEmptyRefList,
    checkInvalidRefList,
    validKor,
    validMobile,
    validEmail,
    validationSet,
    preventSet,
    formatDate,
    formatBusinessNumber,
    formatPhoneNumber,
    makeSpecKey,
    getCourierList,
    getCourierName,
    getParcelLocationList,
    getPickupLocationList,
    getFreightList,
    getCityList,
    getMemberLevelList,
    getPartnerList,
    getCodeList
}
